import {
  PREVIEW_REGEXP,
  segmentProdKey,
  segmentTestKey,
  uatHost,
} from './constants';
import { getHostName } from './hostname';

export const shouldBePlacedAppsFlyer = (countryCode, isHomepage) =>
  countryCode === 'cn' && isHomepage;

export const shouldBePlacedSmartBanner = (countryCode, isHomepage) =>
  countryCode === 'cn' && isHomepage;

function removeCloudProxyPart(url) {
  return url.replace(/^\/browse\/cloud_proxy\/v1\/[^/]*/, '');
}

export const isWeb = () => typeof window !== 'undefined';

export const isProdDomain = () => {
  if (isWeb()) {
    return window.location.host === getHostName();
  }
  return false;
};

export const isPreview = () => {
  if (isWeb()) {
    return PREVIEW_REGEXP.test(removeCloudProxyPart(window.location.pathname));
  }
  return false;
};

export const isUAT = () => {
  if (isWeb()) {
    return getHostName() === uatHost && window.location.host === uatHost;
  }
  return false;
};

export const getSegmentKey = () => {
  if (isWeb() && isProdDomain() && !isPreview() && !isUAT()) {
    return segmentProdKey;
  }

  return segmentTestKey;
};

/**
 * Updates the hostname of a given URL to support a UAT environment.
 *
 * This function takes a URL string as input, checks if the hostname is 'www.nike.com',
 * and if so, updates it to 'uat.nike.com'. It then returns the updated URL string.
 *
 * @param {string} urlToTest - The URL string to be checked and updated.
 * @returns {string} - The updated URL string with the hostname changed to 'uat.nike.com' if applicable.
 *
 * @example
 * // returns 'https://uat.nike.com/path'
 * getUAT('https://www.nike.com/path');
 *
 * @example
 * // returns 'https://afterdarktour.nike.com/en/sydney'
 * getUAT('https://afterdarktour.nike.com/en/sydney');
 */

export const getUAT = urlToTest => {
  try {
    const url = new URL(urlToTest);
    if (url.hostname === 'www.nike.com') {
      url.hostname = getHostName();
    }
    return url.toString();
  } catch {
    // Return original value if anything goes wrong.
    return urlToTest;
  }
};
